import React from 'react';
import { Link } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { Link as RouterLink, useLocation } from 'react-router-dom';

import { palette } from '../theme';
/**
 * What a list hands the detail page it opens, so "back" returns to the same filtered page
 * and says the name of the list it came from - a child's billing tab, not always Invoices.
 */
export interface BackState {
  backTo: string;
  backLabel: string;
}

export const backState = (backTo: string, backLabel: string): { state: BackState } => ({ state: { backTo, backLabel } });

/**
 * "← Invoices" above a detail page's title.
 *
 * Uses where the page was opened from when it knows, and the given list otherwise - a
 * pasted link or a reload has no history to go back to, but still has a list it belongs to.
 */
const BackLink: React.FC<{ fallbackTo: string; fallbackLabel: string }> = ({ fallbackTo, fallbackLabel }) => {
  const location = useLocation();
  const state = location.state as Partial<BackState> | null;
  const to = state?.backTo ?? fallbackTo;
  const label = state?.backLabel ?? fallbackLabel;

  return (
    <Link
      component={RouterLink}
      to={to}
      underline="hover"
      sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.25, fontSize: 14, color: palette.primary.main, mb: 1 }}
    >
      <ChevronLeftIcon sx={{ fontSize: 18 }} />
      {label}
    </Link>
  );
};

export default BackLink;
